<template>
  <div>
    <span v-html="activityMessage"></span>
  </div>
</template>

<script>
export default {
  name: 'TableRestored',
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  computed: {
    activityMessage() {
      const actor = this.activity?.actorUser?.name || 'Bilinmeyen Kullanıcı';
      const tableName = this.activity?.payload?.name || 'İsimsiz Tablo';
      
      return this.$t('notification.tableRestored', {
        actor: `<strong>${actor}</strong>`,
        tableName: `<strong>${tableName}</strong>`
      });
    }
  }
};
</script>

<style scoped>
</style>

